import React, { useEffect, useState } from 'react'
import { Checkbox, TextField } from '@mui/material';
import CouponConfigurableLabel from '../../CouponConfigurableLabel';
import { useSelector } from 'react-redux';
import { validateUsabilityLimits } from './service';
import { UsabilityLimitsProps } from '../../../types';
import { setPercentageMaxAmount, updateDeleteParent, updateUsabilityLimits } from '../../../../../stateManagement/actions/manageCouponActions';
import CouponDate from '../CouponDate/CouponDate';
import dayjs, { Dayjs } from 'dayjs';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { COUPON_TYPE_OPTIONS_VALUE,MetaData } from '../../../utils/utils';
import RequiredFieldIndicator from '../../../../../components/popup/requiredField';
import { isOnlyDigit } from '../../../services/services';


function PercentUsabilityLimit() {
    const { useOnce,percentageMaxAmount} = useSelector((state:any)=>state?.manageCoupons?.data?.usabilityLimits);
    const {deleteParent} = useSelector((state:any)=>state?.manageCoupons?.data)
    const [errors , setErrors] = useState<Record<string,string>>({});
    const {schemeType , couponTypeOption , usabilityLimits} = useSelector((state:any)=>state?.manageCoupons?.data);

    const {couponEditType} = useSelector((state:any)=>state.manageCoupons?.data);
    const handlePercentageMaxDiscount = (e:any)=>{
        const val = e.target.value;
        if (isOnlyDigit(val)) {
            setPercentageMaxAmount(val ?? "")
        }
      }
 




    return (
        <div className='usability-limits-wrapper'>
            {
                MetaData.MakeOnceCheckBox && couponTypeOption !== COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_WELCOME  &&
                <div className="usability-limits-checkbox-wrapper">
                    <CouponConfigurableLabel className={` ${couponEditType === "edit" ? 'blurredStyles' : ''}`} text='USE_ONCE' />
                    <Checkbox value={useOnce} onChange={(e) => { updateUsabilityLimits("useOnce", e.target.checked) }} />
                </div>
            }
            {
                schemeType === "percentage" && 
                <div style={{position:"relative"}}> 
                    <div className={'usability-limits-max-dis-wrapper'}>
                        <div className='usability-limits-labels-wrapper'>
                            <CouponConfigurableLabel text='PERCENTAGE_MAX_AMOUNT' style={{ fontWeight: '600', whiteSpace: 'nowrap' }} />
                            <CouponConfigurableLabel text='PERCENTAGE_MAX_AMOUNT_SUBTITLE' style={{ fontSize: '14px', whiteSpace: 'nowrap' }} />
                        </div>
                        <TextField
                            id='max-discount-field'
                            size='small'
                            value={percentageMaxAmount}
                            onWheel={(e: any) => e.target.blur()}
                            onChange={handlePercentageMaxDiscount}
                            // type='number'
                            placeholder='Write here'
                        />
                    </div>
                </div>
            }        
        </div>
    )
}

export default React.memo(PercentUsabilityLimit)